export default __webpack_public_path__ + "2f7bc363fc5424ebda5903f74c404a99.ttf";